import React, { memo } from 'react';

import { DASHBOARD_PAGE_PATH } from '../../constants/appPathConst';
import CustomButton from './CustomButton';
import bemNames from '../../generalUtils/benames';

const bemClass = bemNames.create('breadcrumb');

const BreadCrumbComponent = ({ breadcrumbs = [] }) => {
  const DEFAULT_BREADCRUMB_NAME = 'Home';

  return (
    <nav aria-label="breadcrumb">
      <ol className={bemClass.b('')}>
        <li className={bemClass.e('item')}>
          <CustomButton isLinkTag to={DASHBOARD_PAGE_PATH}>
            {DEFAULT_BREADCRUMB_NAME}
          </CustomButton>
        </li>

        {breadcrumbs &&
          breadcrumbs.map(({ name, active, isLink, url }, index) => {
            const key = `breadcrumb_${index}`;
            return (
              <li className={bemClass.e('item active')} key={key} data-active={active} aria-current="page">
                {isLink ? (
                  <CustomButton isLinkTag to={url} rel="noopener noreferrer">
                    {name}
                  </CustomButton>
                ) : (
                  name
                )}
              </li>
            );
          })}
      </ol>
    </nav>
  );
};

BreadCrumbComponent.displayName = 'BreadCrumbComponent';
export default memo(BreadCrumbComponent);
